import React, { useRef, useState, useEffect } from "react";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Grid} from '@mui/joy';
import CategorySlider from "../Slider";
import { Button, Typography } from "@mui/material";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styles from './styles.js';
import { createTheme } from '@mui/system';
// import { emulatorScreen, mobileScreen } from '../../../utils/index.js';
const theme = createTheme();


const Question = (props) => {
  // console.log("[emulatorScreen(theme)]", [mobileScreen(theme)])
  const [p0, setP0] = useState(10)
  const [p1, setP1] = useState(10)
  const [p2, setP2] = useState(10)
  const [p3, setP3] = useState(10)
  const [p4, setP4] = useState(10)
  const [p5, setP5] = useState(10)
  // const [p6, setP6] = useState(10)
  const [p7, setP7] = useState(10)
  // const [extra, setExtra] = useState(0)
  const [errorDisplay, setErrorDisplay] = useState("")
  const [percentage, setPercentage] = useState(70)
  const [percentageColor, setPercentageColor] = useState("red")
  const { setCurrentScreen, setAnswers, question } = props
  const { Title, GraphHeading, QuestionMarkers, TotalText, PercentageText, Number, SubmmitButton } = styles
  const data = [
    { id: 0, value: p0, color: "#54AFD3", cusLabel: "Social Security", label: 'Social Security' },
    { id: 1, value: p1, color: "#77DB93", cusLabel: "Health", label: 'Health' },
    { id: 2, value: p2, color: "#AEC6CF", cusLabel: "Defense", label: 'Defense' },
    { id: 4, value: p3, color: "#838BDA", cusLabel: "Unemployment", label: 'Unemployment, Welfare and Other Relief' },
    { id: 3, value: p4, color: "#5186EA", cusLabel: "Interest on Debt", label: 'Interest on the Debt' },
    { id: 5, value: p5, color: "#B4E9D0", cusLabel: "Veterans Benefits", label: "Veterans Benefits" },
    // { id: 6, value: p6, color: "#00FFFF", cusLabel: "Education", label: 'Education,Training\n Services' },
    { id: 7, value: p7, color: "#DBA1D9", cusLabel: "Other", label: 'Other' },
    // { id: 8, value: extra, color: "#808080", cusLabel: "Extra", label: 'Extra' },
  ]
  const [style, setStyle] = useState({ height: 550 });

  const mobileScreen = theme => '(max-width: 900.95px) and (max-height: 440px)';
  const laptopScreen = theme => '(max-height: 900px)';
  const emulatorScreen = theme => '(max-width: 1200px)';

  useEffect(() => {
    const applyInitialStyles = () => {
      const mobileScreenQuery = mobileScreen(theme);
      const laptopScreenQuery = laptopScreen(theme);
      const emulatorScreenQuery = emulatorScreen(theme);

      if (window.matchMedia(mobileScreenQuery).matches) {
        setStyle({ height: 240, labelFont: 10, innerRadius: 15, outerRadius: 100 })
      } else if (window.matchMedia(laptopScreenQuery).matches) {
        setStyle({ height: 380, width: 380, labelFont: 11, innerRadius: 50, outerRadius: 130 });
      } else if (window.matchMedia(emulatorScreenQuery).matches) {
        setStyle({ height: 450,  width: 450, labelFont: 12, innerRadius: 60, outerRadius: 150 });
      } else {
        setStyle({ height: 550, width: 550, labelFont: 14, innerRadius: 80, outerRadius: 250 })
      }
    };
    applyInitialStyles();
    window.addEventListener('resize', applyInitialStyles);
    return () => window.removeEventListener('resize', applyInitialStyles);
  }, [theme]);

  const TOTAL = data.map((item) => item.value).reduce((a, b) => a + b, 0);

  const getArcLabel = (params) => {
    const percent = params.value / TOTAL;
    if (percent < 0.01) {
      return null;
    }
    // console.log(p0)
    return `${params.cusLabel} ${params.value.toFixed(0)}%`;
  };

  const pieChart = () => {
    return (<PieChart
      series={[
        {
          data: data,
          innerRadius: style.innerRadius,
          outerRadius: style.outerRadius,
          arcLabel: getArcLabel
        },
      ]}
      margin={{left: 100}}
      height={style.height}
      slotProps={{
        legend: {
          hidden: true,
          direction: 'row',
          // position: { vertical: 'middle', horizontal: 'right' },
          // padding: 0,
          // itemGap: 15
        },
      }}
      sx={{
        [`& .${pieArcLabelClasses.root}`]: {
          fill: '#404040',
          fontSize: style.labelFont,
          fontFamily: "Rubik"
          // textAnchor:'middle',
          // transform: 'translate(0, -50%)',
        },
      }}
    />)
  }

  useEffect(() => {
    setPercentageColor(percentage == 100 ? "green" : "red")
  }, [percentage])

  const allowChange = (change) => {
    setPercentage(percentage + change)
    return true
    // if(p0 + p1 + p2 + p3 + p4 + p5 + p7 + change <= 100) {
    //   // setExtra(extra - change)
    //   setErrorDisplay("")
    //   return true
    // }
    // else {
    //   setErrorDisplay("Total should be between 0 and 100")
    //   return false
    // }
  }

  const submitAnswer = () => {
    setAnswers({
      Security: p0,
      Health: p1,
      Defense: p2,
      Unemployment: p3,
      Interest: p4,
      Veteran: p5,
      Other: p7,
    })
    setCurrentScreen("Answer")
  }

  const remaingPercentage =() => {
    let diff = percentage - 100
    return diff > 0 ? `+${diff}` : diff
  }

  const toltipComponent = () => {
    return(
    <Grid style={{ width: 300, backgroundColor: 'red', padding: 10, margin: "-5px -10px", borderRadius: 10 }}>
      { percentage < 100 ?
        <Typography style={{  display: "flex", fontSize: 22 }} >Your total is too low. It must add up to 100%.</Typography>
      : percentage > 100 ?
        <Typography style={{  display: "flex", fontSize: 22 }}>Your total is too high. It must add up to 100%.</Typography>
        : null
      }
    </Grid>
    )
  }

  return(
    <Grid container alignItems={'center'} justifyContent={'center'} padding={0}>
      {/* <Typography color={'red'} padding={1} align="center" height={30}>{errorDisplay}</Typography> */}
      <Grid container spacing={2} padding={2} xs={12} justifyContent={'center'}>
        <Grid container xs={5} md={5}>
          <Title>Make a guess</Title>
          <CategorySlider setValue={setP0} value={p0} color={"#54AFD3"} allowChange={allowChange} tooltipText={question.tooltip["Security"]} name={"Social Security"} />
          <CategorySlider setValue={setP1} value={p1} color={"#77DB93"} allowChange={allowChange} tooltipText={question.tooltip["Health"]} name={"Health"} />
          <CategorySlider setValue={setP2} value={p2} color={"#AEC6CF"} allowChange={allowChange} tooltipText={question.tooltip["Defense"]} name={"Defense"} />
          <CategorySlider setValue={setP3} value={p3} color={"#838BDA"} allowChange={allowChange} tooltipText={question.tooltip["Unemployment"]} name={"Unemployment, Welfare and Other Relief"} />
          <CategorySlider setValue={setP4} value={p4} color={"#5186EA"} allowChange={allowChange} tooltipText={question.tooltip["Interest"]} name={"Interest on the Debt"} />
          <CategorySlider setValue={setP5} value={p5} color={"#B4E9D0"} allowChange={allowChange} tooltipText={question.tooltip["Veteran"]} name={"Veterans Benefits"} />
          {/* <CategorySlider setValue={setP6} value={p6} color={"#00FFFF"} allowChange={allowChange} name={"Education,Training Services"} /> */}
          <CategorySlider setValue={setP7} value={p7} color={"#DBA1D9"} allowChange={allowChange} tooltipText={question.tooltip["Other"]} name={"Other"} />
        </Grid>
        <Grid container xs={6} justifyContent={'center'}>
          <GraphHeading>
            {question.title}
            <Tooltip title="What share of U.S. federal spending goes to which budget items? Source: Peter G. Peterson Foundation">
              <IconButton>
                <QuestionMarkers />
              </IconButton>
            </Tooltip>
          </GraphHeading>
          <Grid container xs={12} justifyContent={'center'}>
            {pieChart()}
          </Grid>
        </Grid>
      </Grid>
      <Grid container xs={12} justifyContent={"space-evenly"}>
        <Grid container justifyContent={'center'} alignItems={'center'} style={{ width: "33%" }}>
          <TotalText>Total: </TotalText>
          <PercentageText> {percentage}% </PercentageText>
          <Number style={{ color: percentageColor }}> ({remaingPercentage()}%) </Number>
        </Grid>
        <Tooltip title={toltipComponent()} disableHoverListener={percentage == 100} placement={'top'}>
          <SubmmitButton style={{ backgroundColor: percentage !== 100 ? "grey" : "#00b1d9" }}
          onClick={() =>  percentage == 100 && submitAnswer()}
          className={`${percentage == 100 && "animate__animated animate__bounceIn"}`}
          >
            SUBMIT
          </SubmmitButton>
        </Tooltip>
        <Grid style={{ width: "33%" }}></Grid>
      </Grid>
    </Grid>
  )
}

// Use it if you don't plan to use "remount"
// document.addEventListener('DOMContentLoaded', () => {
  // ReactDOM.render(, document.getElementById('hello'))
// })

export default Question
